export const defaultAffiliateId = () =>
  parseInt(process.env.VUE_APP_SELF_ASSESSMENT_DEFAULT_AFFILIATE as string, 10);
